import React from 'react'
import ContentLoader from 'react-content-loader'
import styled from 'styled-components'

export default ({ width, height }) =>
  <ContentLoader
    height={height}
    width={width}
    speed={2}
    primaryColor='#f3f3f3'
    secondaryColor='#ecebeb'>
    <rect x='0' y='0' rx='0' ry='0' width={width} height={height} />
  </ContentLoader>

export const LoaderWrapper = styled.div`
  overflow: hidden
`



// WEBPACK FOOTER //
// ./src/components/Loader.js